import React from 'react'
import {classByArray} from "../../../utils/htmlUtils";

interface InputProps {
    error?: boolean
    name: string
    value: any
    type: string
    disabled?: boolean
    changeValue: (
        data: any,
        event: React.ChangeEvent<HTMLTextAreaElement>
    ) => void
}

const Textarea = ({
                      changeValue,
                      type,
                      name,
                      error,
                      value,
                      disabled,
                      ...rest
                  }: InputProps) => {
    const changeInput = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (changeValue) {
            changeValue(event.target.value, event)
        }
    }
    const classArray = ['form-control shared-textArea', ...(error ? ['error'] : [])]
    return (
        <>
      <textarea
          className={classByArray(classArray)}
          name={name}
          value={value}
          onChange={changeInput}
          disabled={disabled}
          {...rest}
      />
        </>
    )
}

export default Textarea
